import React from 'react';
import styled from 'styled-components';
import { FaBuilding, FaRoad, FaBook, FaLaptopCode } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const CategoriesSection = styled.section`
  background-color: ${props => props.theme.colors.white};
  padding: 80px 0;
`;

const OverviewContent = styled.div`
  max-width: 800px;
  margin: 0 auto 50px;
  text-align: center;
  
  p {
    margin-bottom: 15px;
    color: ${props => props.theme.colors.grey[600]};
    line-height: 1.8;
  }
`;

const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const CategoryCard = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const CategoryIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(52, 152, 219, 0.1);
  color: ${props => props.theme.colors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0 auto 20px;
`;

const CategoryTitle = styled.h3`
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const CategoryDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
`;

const CourseCategories = () => {
  const categories = [
    {
      id: 1,
      title: 'Structural Engineering',
      description: 'Specialized courses focusing on structural analysis, design principles, and advanced methodologies.',
      icon: <FaBuilding />
    },
    {
      id: 2,
      title: 'Civil Engineering',
      description: 'Comprehensive courses covering various aspects of civil engineering theory and practice.',
      icon: <FaRoad />
    },
    {
      id: 3,
      title: 'Exam Preparation',
      description: 'Focused coaching for competitive exams including TNPSC Technical Services.',
      icon: <FaBook />
    },
    {
      id: 4,
      title: 'Software Training',
      description: 'Hands-on training in industry-standard structural design and analysis software.',
      icon: <FaLaptopCode />
    }
  ];

  return (
    <CategoriesSection>
      <div className="container">
        <SectionHeader 
          title="Transforming Engineering Education" 
          subtitle="Discover our comprehensive range of courses designed for aspiring engineers" 
        />
        
        <OverviewContent>
          <p>
            At KALS Academy, we offer specialized courses in structural engineering, civil engineering, 
            and competitive exam preparation. Our curriculum combines theoretical knowledge with practical 
            applications to prepare students for successful careers in the field.
          </p>
          <p>
            All our courses are led by experienced professionals with extensive industry knowledge and 
            teaching expertise. We focus on small batch sizes to ensure personalized attention and better 
            learning outcomes.
          </p>
        </OverviewContent>
        
        <CategoriesGrid>
          {categories.map(category => (
            <CategoryCard key={category.id}>
              <CategoryIcon>{category.icon}</CategoryIcon>
              <CategoryTitle>{category.title}</CategoryTitle>
              <CategoryDescription>{category.description}</CategoryDescription>
            </CategoryCard>
          ))}
        </CategoriesGrid>
      </div>
    </CategoriesSection>
  );
};

export default CourseCategories;
